import React, { useEffect, useRef, useState } from 'react';
import { usePurchaseRequestApi } from '../../../store/api/hooks/purchaseApiHook';
import Layout from '../../../components/layout';
import Header from '../../../components/header';
import Drawer from '../../../components/Drawer';
import Button from '../../../components/elements/button';
import { Dropdown, Menu } from '../../../components/Dropdown';
import Pagination from '../../../components/pagination';
import Search from '../../../components/search';
import Icon from '../../../components/icons';
import { AgGridReact } from 'ag-grid-react';
import Loader from '../../../components/loader';
import { PAGE_SIZE } from '../../../_common/constant';
import { StatusStaticPRCell, titleCell } from '../../../components/elements/function';
import { downloadExcel, downloadPDF, showLocalDate, getPermissionInfo } from '../../../_common/functions';
import toast from 'react-hot-toast';
import Filters from '../../../components/filters';
import { filterConfigType } from '../../../_config/types';
import { useDialog } from '../../../store/api/hooks/dialogHook';
import { useCommonApi } from '../../../store/api/hooks/commonApiHook';
import { useSpearPartsApi } from '../../../store/api/hooks/spearPartsApiHook';
import { useFacilitiesApi } from '../../../store/api/hooks/facilitiesApiHook';
import CreateReceipt from './_components/createReceipt';
import { useReceiptApi } from '../../../store/api/hooks/receiptApiHook';
import { usePurchaseOrderApi } from '../../../store/api/hooks/purchaseOrderApiHook';
import Currency from '../../../components/currency';
import ViewReceipt from './_components/viewReceipt';
import { useUserSelector } from '../../../store/selectors/userSelector';
import { useLocation } from 'react-router-dom';

const ReceiveStock: React.FC = () => {
    const loggedinuser: any = useUserSelector();
    const location = useLocation();
    const prAPI = usePurchaseRequestApi();
    const [currentPage, setCurrentPage] = useState<number>(1);
    const [searchParam, setSearchParam] = useState<string>('');
    const [totalRecords, setTotalRecords] = useState<number>(0);
    const [gridApi, setGridApi] = useState<any>(null);
    const [gridColumnApi, setGridColumnApi] = useState<any>(null);
    const [rowData, setrowData] = useState<any>(null);
    const [filters, setFilters] = useState<any>({});
    const [filtersApplied, setFiltersApplied] = useState<any>({ generalFilter: false, locationFilter: false });
    const [filtersInitialized, setFiltersInitialized] = useState<boolean>(false);

    // Load filters from localStorage on component mount
    useEffect(() => {
        const savedFilters = localStorage.getItem('receiveStockFilters');
        if (savedFilters) {
            try {
                const parsedFilters = JSON.parse(savedFilters);
                setFilters(parsedFilters);
            } catch (error) {
                console.error('Error parsing saved filters:', error);
                setFilters({});
            }
        } else {
            setFilters({});
        }
        setFiltersInitialized(true);
    }, []);

    // Save filters to localStorage when filters change
    useEffect(() => {
        if (Object.keys(filters).length > 0) {
            localStorage.setItem('receiveStockFilters', JSON.stringify(filters));
        }
    }, [filters]);
    const [selectedPRid, setSelectedPRid] = useState<any>(null);
    const [viewMode, setViewMode] = useState<'view' | 'approve'>('view');
    const filtersRef: any = useRef();
    const { confirm } = useDialog();
    const createReceiptRef = useRef<any>(null);
    const viewprRef = useRef<any>(null);
    const commonApi: any = useCommonApi();
    const spearPartsAPI = useSpearPartsApi();
    const facilityApi: any = useFacilitiesApi();
    const receiveStockApi: any = useReceiptApi();
    const prorderAPI: any = usePurchaseOrderApi();

    const [purchaseRequestTypeOptions, setPurchaseRequestTypeOptions] = useState<any[]>([]);
    const [purchaseRequestStatusOptions, setPurchaseRequestStatusOptions] = useState<any[]>([]);
    const [facilityoption, setFacilityoption] = useState<any>([]);
    const [vendorlist, setvendorList] = useState<any>([]);


    const getUserList = (s: string) => {
        return new Promise((resolve, reject) => {
            let payload: any = {};
            if (s !== '') {
                payload.searchParam = s;
            }

            commonApi.GetUserList(payload, (resp: any) => {
                resolve(resp.userList ? resp.userList.map((user: any) => {
                    return {
                        label: user.firstName + " " + user.lastName,
                        value: user.userID,
                    };
                }) : []);
            }, (error: any) => { reject(false) });
        });
    }

    const getSpearPartsList = (s: string) => {
        return new Promise((resolve, reject) => {
            let payload: any = {};
            if (s !== '') {
                payload.searchParam = s;
            }

            spearPartsAPI.getSpearPartsList(payload, (resp: any) => {
                resolve(resp.sparePartsList ? resp.sparePartsList.map((part: any) => {
                    return {
                        label: part.sparePartsName,
                        value: part.partsID,
                    };
                }) : []);
            }, (error: any) => { reject(false) });
        });
    };

    const GetPurchaseOrderList = (s: string) => {
        return new Promise((resolve, reject) => {
            let payload: any = {};
            if (s !== '') {
                payload.searchParam = s;
            }

            prorderAPI.getOrderList(payload, (resp: any) => {
                resolve(resp.purchaseOrderList ? resp.purchaseOrderList.map((polist: any) => {
                    return {
                        label: polist.purchaseOrderCode,
                        value: polist.purchaseOrderID,
                    };
                }) : []);
            }, (error: any) => { reject(false) });
        });
    };

    const GetVendorList = (s: string) => {
        return new Promise((resolve, reject) => {
            let payload: any = {};
            if (s !== '') {
                payload.searchParam = s;
            }

            commonApi.GetServiceprovidertList(payload, (resp: any) => {
                resolve(resp.vendorList ? resp.vendorList.map((venlist: any) => {
                    return {
                        label: venlist.name,
                        value: venlist.vendorID,
                    };
                }) : []);
            }, (error: any) => { reject(false) });
        });
    };

    const getfacilitylist = () => {
        const payload = {};
        facilityApi.getFacilityList(
            payload,
            (resp: any) => {
                let facilitylist: any = [];
                resp.facilityList.map((facility: any) => {
                    facilitylist.push({
                        label: facility.facilityName,
                        value: facility.facilityID,
                        data: facility
                    });
                });
                setFacilityoption(facilitylist);
            },
            (error: any) => {
                console.log("error =>", error);
                toast.error(error);
            }
        );
    };


    const filterConfig: filterConfigType[] = [
        { name: 'Vendor', type: 'dropdown', key: 'vendorIDs', async: GetVendorList as any },
        { name: 'Purchase Order', type: 'dropdown', key: 'purchaseOrderIDs', async: GetPurchaseOrderList as any },
        { name: 'Receipt Date', type: 'date-range', key: 'receiptStartDate,receiptEndDate' },
        { name: 'Created By', type: 'dropdown', key: 'requesterIDs', async: getUserList as any },
        { name: 'Created Date', type: 'date-range', key: 'createdStartDate,createdEndDate' },
        { name: 'Items', type: 'dropdown', key: 'partIDs', async: getSpearPartsList as any },
    ]


    const columnDefs = [
        { headerCheckboxSelection: true, checkboxSelection: true, width: 50, headerClass: 'bg-[#f0f0f0]' },
        {
            headerName: 'Receipt No',
            field: 'receiptCode',
            headerClass: 'bg-[#f0f0f0]',
            width: 280,
            cellRenderer: (data: any) => (
                <p className='hover:text-primary font-semibold cursor-pointer' title={data.value}>{data.value}</p>
            ),
            onCellClicked: (param: any) => {
                setSelectedPRid(param.data.receiptID);
                viewprRef.current?.open();
            }
        },
        {
            headerName: 'PO Number', field: 'purchaseOrderCode', headerClass: 'bg-[#f0f0f0]', width: 280,
            cellRenderer: (data: any) => (
                <p className='hover:text-primary' title={data.value}>{data.value}</p>
            )
        },
        {
            headerName: 'Vendor Name', field: 'vendorName', headerClass: 'bg-[#f0f0f0]', width: 170, cellRenderer: titleCell
        },
        {
            headerName: 'Facility', field: 'facilityName', headerClass: 'bg-[#f0f0f0]', flex: 1, minWidth: 150, cellRenderer: titleCell
        },
        {
            headerName: 'Receiving Value', field: 'receivingAmount', headerClass: 'bg-[#f0f0f0] ag-right-aligned-header', width: 150, cellClass: 'ag-right-aligned-cell', cellRenderer: (params: any) => (
                <Currency
                    currency="USD"
                    value={Number((params.value ?? 0).toFixed(2))}
                />
            )
        },
        {
            headerName: 'Received On', field: 'receiptDate', headerClass: 'bg-[#f0f0f0]', flex: 1, minWidth: 160, cellRenderer: (data: any) => (
                <p className='hover:text-primary'>{showLocalDate(data.value)}</p>
            )
        },
        { headerName: 'Received By', field: 'receiptByName', headerClass: 'bg-[#f0f0f0]', width: 230, cellRenderer: titleCell },
        {
            headerName: "Actions",
            field: "actions",
            headerClass: 'bg-[#f0f0f0] text-center',
            pinned: 'right',
            width: 90,
            cellRenderer: (params: any) => {
                const statusID = params?.data?.purchaseRequestStatusID;

                return (
                    <div className='relative h-full w-full flex items-center justify-center'>
                        <Icon name='threedote' size={1.25} className='text-[#000000]' />
                        <select
                            onChange={(e) => {
                                handleActionChange(e, params);
                                e.target.selectedIndex = -1;
                            }}
                            onFocus={(e) => e.target.selectedIndex = -1}
                            className="action-dropdown"
                            value={''}
                            style={{
                                position: "absolute",
                                top: 0,
                                left: 0,
                                width: "100%",
                                height: "100%",
                                opacity: 0,
                                cursor: "pointer",
                            }}
                        >
                            <option value="view">View</option>
                        </select>
                    </div>
                );
            }
        }
    ];


    const handleActionChange = (e: any, params: any) => {
        const action = e.target.value;
        const rowData = params.data;

        switch (action) {
            case "view":
                setSelectedPRid(rowData.receiptID);
                viewprRef.current?.open();
                break;
            default:
                console.log("Unknown action: ", action);
                break;
        }
        e.target.selectedIndex = -1;
    };

    const onGridReady = (params: any) => {
        setGridApi(params.api);
        setGridColumnApi(params.columnApi);
    };

    const onRowClicked = (event: any) => {
        if (!event.event.target.closest('input[type="checkbox"]')) {
            event.node.setSelected(false);
        }
    };

    const getSelectedRows = () => {
        const selectedNodes = gridApi?.getSelectedNodes();
        const selectedData = selectedNodes.map((node: any) => node.data);
        return selectedData;
    };

    const onBulkExportPdf = () => {
        if (!getPermissionInfo(location.pathname, "Export", loggedinuser)) {
            toast.error("You don't have Export permission");
            return;
        }

        const selectedData = getSelectedRows();
        const payload: any = {};
        if (selectedData.length > 0) {
            const receiptIDs = selectedData.map((rs: any) => rs.receiptID).join(',');
            payload.receiptIDs = receiptIDs;
        }
        receiveStockApi.ExportToPdf(
            payload,
            (resp: any) => {
                //downloadPDF(resp, 'ReceiptStock');
                window.open(resp.fileUrl, '_blank', 'ReceiptStock');
            },
            (error: any) => {
                console.log("error =>", error);
                toast.error(error);
            }
        );
    };


    const onBulkExportCsv = async () => {
        if (!getPermissionInfo(location.pathname, "Export", loggedinuser)) {
            toast.error("You don't have Export permission");
            return;
        }

        const selectedData = getSelectedRows();
        const payload: any = {};
        if (selectedData.length > 0) {
            const receiptIDs = selectedData.map((rs: any) => rs.receiptID).join(',');
            payload.receiptIDs = receiptIDs;
        }
        receiveStockApi.ExportToXls(
            payload,
            (resp: any) => { //downloadExcel(resp, 'ReceiptStock')
                window.open(resp.fileUrl, '_blank', 'ReceiptStock');
            },
            (error: any) => {
                console.log("error =>", error);
                toast.error(error);
            }
        );
    };


    const GetReceiveStockList = () => {
        const payload: any = {
            pageSize: PAGE_SIZE,
            pageNumber: currentPage,
            searchParam: searchParam,
        };

        if (filters) {
            Object.keys(filters).map((key: any) => {
                if (filters[key]) {
                    payload[key] = filters[key];
                }
            });
        }
        setrowData(null);
        receiveStockApi.GetReciptList(payload, (resp: any) => {
            setrowData(resp.receiptList ? resp.receiptList : []);
            setTotalRecords(resp.totalRecord);

        }, (error: any) => {
            console.log('error =>', error);
            toast.error(error);
        });
    };

    useEffect(() => {
        getfacilitylist();
    }, []);

    // Call GetReceiveStockList only after filters are initialized
    useEffect(() => {
        if (filtersInitialized) {
            GetReceiveStockList();
        }
    }, [filters, filtersInitialized]);

    useEffect(() => {
        if (filtersInitialized) {
            GetReceiveStockList();
        }
        
        const hasActiveFilters = filterConfig.some((filter) => filters[filter.key]);
        const hasActiveLocationFilter = filters?.hasOwnProperty("facilityIDs");
        setFiltersApplied({
            generalFilter: hasActiveFilters,
            locationFilter: hasActiveLocationFilter,
        });
    }, [currentPage, searchParam, filters]);

    return (
        <Layout>
            <Header title='Receive Stock'>
                <Header.Right>
                    <Drawer _ref={createReceiptRef} isAfterOpenRender={true} onClose={() => {

                    }}>
                        <Drawer.Button>
                            <Button disabled={!getPermissionInfo(location.pathname, "Add", loggedinuser)}>
                                New Receipt
                            </Button>
                        </Drawer.Button>
                        <Drawer.Content title='New Receipt' className='!w-[68rem]'>
                            {!getPermissionInfo(location.pathname, "Add", loggedinuser) ? (
                                <div className="p-4 text-red-500">
                                    You don't have permission to access this form.
                                </div>
                            ) : (
                                <CreateReceipt onCreate={() => {
                                    createReceiptRef.current?.close();
                                    GetReceiveStockList();
                                }} onCancel={() => {
                                    createReceiptRef.current?.close();
                                }} />
                            )}
                        </Drawer.Content>
                    </Drawer>
                    <Drawer _ref={viewprRef} isAfterOpenRender={true} onClose={() => setSelectedPRid(null)}>
                        <Drawer.Button> <div style={{ display: 'none' }}></div> </Drawer.Button>
                        <Drawer.Content title="View Receive Stock" className='!w-[60rem] !pr-0'>
                            <ViewReceipt PrID={selectedPRid} onCreate={() => { viewprRef.current?.close(); setSelectedPRid(null); }} onCancel={() => { setSelectedPRid(null); viewprRef.current?.close(); }} />
                        </Drawer.Content>
                    </Drawer>
                    <Dropdown>
                        <Dropdown.Button>
                            <Button theme='secondary'>Bulk Actions</Button>
                        </Dropdown.Button>
                        <Dropdown.Content title='Create New Receive Stock'>
                            <Menu disabled={!getPermissionInfo(location.pathname, "Export", loggedinuser)} onClick={onBulkExportCsv}>Export excel / csv </Menu>
                            <Menu disabled={!getPermissionInfo(location.pathname, "Export", loggedinuser)} onClick={onBulkExportPdf}>Export pdf</Menu>
                        </Dropdown.Content>
                    </Dropdown>
                </Header.Right>
            </Header>

            <div className='flex items-center justify-between pl-5 pr-3 border-b border-gray-200 h-[3.75rem]'>
                <Pagination
                    perPage={PAGE_SIZE}
                    totalRecords={totalRecords}
                    onPageChange={setCurrentPage}
                    currentPage={currentPage}
                />
                <Search onSearch={setSearchParam} placeholder='Search by receipt no or po no' />
            </div>

            <div className='bg-[#FAFAFA]'>
                <div className='flex gap-4 px-5 py-2 items-center'>
                    <Button theme='light' onClick={() => filtersRef.current.showModal()}>
                        Filter <Icon name='filter' size={1.40} className={filtersApplied.generalFilter ? "text-blue-700" : ""} />
                    </Button>
                    <Dropdown>
                        <Dropdown.Button>
                            <Button theme='light'><Icon name='grlocation' size={1.20} className={filtersApplied.locationFilter ? "text-blue-700" : ""} /> Location <Icon name='arrowdown' size={1.10} /></Button>
                        </Dropdown.Button>
                        <Dropdown.Content >
                            {facilityoption?.map((facility: any) => {
                                return (
                                    <Menu onClick={() => {
                                        console.log('facility', facility);
                                        setFilters({ ...filters, facilityIDs: [facility.value] })
                                    }}>{facility.label}</Menu>
                                )
                            }
                            )}
                        </Dropdown.Content>
                    </Dropdown>
                    <p className='text-primary font-semibold text-sm cursor-pointer' onClick={() => {
                        setFilters({});
                        localStorage.removeItem('receiveStockFilters');
                        setFiltersApplied({ generalFilter: false, locationFilter: false });
                        setCurrentPage(1);
                    }}>
                        Clear Filters
                    </p>
                </div>

                <div className="ag-theme-alpine mx-4 h-1/2">
                    <AgGridReact
                        columnDefs={columnDefs as any}
                        rowData={rowData || []}
                        pagination={false}
                        rowSelection="multiple"
                        onGridReady={onGridReady}
                        domLayout="autoHeight"
                        onRowClicked={onRowClicked}
                        loadingOverlayComponent={Loader}
                        noRowsOverlayComponent={() => (
                            <div className="flex items-center justify-center h-full">
                                <div className="text-center text-gray-500">
                                    <div className="text-lg font-medium">No Data Found</div>
                                </div>
                            </div>
                        )}
                    />
                </div>
            </div>
            <Filters _ref={filtersRef} config={filterConfig} filters={filters} onUpdate={setFilters} />
        </Layout>
    );
};

export default ReceiveStock;